import constants from 'app/constants'
import fetchJSONData from 'app/util/fetchJSONData'

let dataCache

/**
 * Get the account special offers
 *
 * @returns {Promise} resolves on completion
 */
const getSpecialOffers = async () => {
  if (dataCache) {
    // Return from cache
    return dataCache
  }

  const res = await fetchJSONData(
    `${constants.PATH_DATA}/account_offers.json?ver=${constants.CACHE_BUST_VERSION}`,
    {
      method: 'GET',
      headers: {
        'company-id': constants.API_ID,
        'Content-Type': 'application/json'
      }
    },
    false
  )

  if (res.success) {
    dataCache = res
  }

  return res
}

export default getSpecialOffers
